(function() {
                        var src = "";
                        if (document.currentScript && document.currentScript.src) {
                            src = document.currentScript.src;
                        } else {
                            var scripts = document.getElementsByTagName("script");
                            if (scripts.length) src = scripts[scripts.length - 1].src || "";
                        }
                        if (!src) return;
                        var url = new URL(src, document.baseURI);
                        var p = url.pathname || "";
                        var i = p.indexOf("/scripts/");
                        if (i === -1) i = p.indexOf("/styles/");
                        var base = i !== -1 ? p.slice(0, i + 1) : "/";
                        url.pathname = base;
                        url.search = "";
                        url.hash = "";
                        __webpack_require__.p = url.toString();
                    })();